import {
    USER_ACHIEVEMENTS_PENDING,
    USER_ACHIEVEMENTS_DOWNLOADED,
    USER_ACHIEVEMENTS_FAILED,
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: null,
    pending: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case USER_ACHIEVEMENTS_PENDING:
            return {
                ...state,
                pending: true,
            };
        case USER_ACHIEVEMENTS_DOWNLOADED:
            return {
                ...state,
                pending: false,
                content: action.payload,
            };
        case USER_ACHIEVEMENTS_FAILED:
            return {
                ...state,
                pending: false,
                error: action.payload,
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/userachievements/reducers.js